exports.onClientEntry = () => {
  if (typeof document !== "undefined") {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/lightbox/lightbox.min.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "/lightbox/lightbox.min.js";
    document.body.appendChild(script);
  }
};
